import { Fragment } from 'react';
import { isRich } from '@/components/common/rich-text/richText';
import { LINK_RE } from '@/components/common/rich-text/extensions';
import { photoSrc, sizeKey } from '@/components/common/rich-text/photo';

// Formatted text (sanitized by the server) rebuilt as React elements: only the tags and inline styles the editor
// makes. Never raw HTML into the page. Links: web / email only, always a new tab. Photos: only our own uploads.
const TAGS = { P: 'p', BR: 'br', UL: 'ul', OL: 'ol', LI: 'li', SPAN: 'span', STRONG: 'strong', EM: 'em', U: 'u', B: 'b', I: 'i' };
const STYLES = { color: 'color', 'font-size': 'fontSize', 'font-family': 'fontFamily', 'text-align': 'textAlign' };
export const PROSE = '[&>*+*]:mt-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_a]:text-[#4575A8] [&_a]:underline [&_a]:underline-offset-2';

function styleOf(el) {
  const out = {};
  Object.entries(STYLES).forEach(([css, js]) => { const val = el.style?.getPropertyValue(css); if (val) out[js] = val; });
  return Object.keys(out).length ? out : undefined;
}

function photo(node, key) {
  const src = photoSrc(node.getAttribute('src'));
  const num = (a) => (/^\d+$/.test(node.getAttribute(a) || '') ? Number(node.getAttribute(a)) : undefined);
  return src ? <img key={key} src={src} alt="" width={num('width')} height={num('height')} data-size={sizeKey(node.getAttribute('data-size'))} loading="lazy" /> : null;
}

export function toReact(node, key) {
  if (node.nodeType === 3) return node.textContent;
  if (node.nodeType !== 1) return null;
  if (node.tagName === 'IMG') return photo(node, key);
  const Tag = TAGS[node.tagName];
  if (Tag === 'br') return <br key={key} />;
  const kids = [...node.childNodes].map((c, i) => toReact(c, i));
  const href = node.tagName === 'A' ? node.getAttribute('href') : null;
  if (href && LINK_RE.test(href)) return <a key={key} href={href} target="_blank" rel="noopener noreferrer nofollow">{kids}</a>;
  return Tag ? <Tag key={key} style={styleOf(node)}>{kids}</Tag> : <Fragment key={key}>{kids}</Fragment>;
}

export default function RichView({ html, className = '', tid }) {
  if (!html) return null;
  if (!isRich(html)) return <div className={`whitespace-pre-line ${className}`} data-testid={tid}>{html}</div>;
  const body = new DOMParser().parseFromString(html, 'text/html').body;
  return <div className={`${PROSE} ${className}`} data-testid={tid}>{[...body.childNodes].map((n, i) => toReact(n, i))}</div>;
}
